import title from './title';
import vehicle from './vehicle';
import highlightedAttrsConfig from './highlightedAttrsConfig';

const root = {
	title,
	vehicle,
	highlightedAttrsConfig
};

export default root;
